import { GalleryIDEnum, IGalleryData, IGalleryItem } from '@models/gallery-list';
import { my_works_list } from '@config/my-works-config';
import { cabinet_works_list } from '@config/cabinet-config';

export const gallery_list: Array<IGalleryItem> = [
  {
    id: GalleryIDEnum.CABINET,
    name: 'Кабинет Редкостей',
  },
];

export const gallery_data: IGalleryData = {
  [GalleryIDEnum.MY_WORKS]: my_works_list,
  [GalleryIDEnum.CABINET]: cabinet_works_list,
};
